// Utility functions for text cleaning and processing
// Moved from aiEnrichment.ts to avoid bundling API keys in client-side code

// Function to clean text fields and prevent JSON contamination
export const cleanTextField = (val: any, fieldName?: string): string | null => {
  if (val === null || val === undefined || val === '') return null;
  if (typeof val !== 'string') return null;
  const trimmed = val.trim();
  if (trimmed === '') return null;
  // Check for any bracket or JSON-like content anywhere
  if (/[{}\[\]]/.test(trimmed)) return null;
  // Try parsing as JSON
  try { JSON.parse(trimmed); return null; } catch {}
  // For notes, be more lenient - only require it to be a meaningful string
  if (fieldName === 'notes' && trimmed.length < 10) return null;
  // Allow colons in notes (they're common in notes)
  if (fieldName === 'notes' && trimmed.includes(':') && trimmed.length < 20) return null;
  // Require at least one letter
  if (!/[a-zA-Z]/.test(trimmed)) return null;
  return trimmed;
};

// Helper to strip contact info from text fields
export function stripContactInfo(text: string | null): string | null {
  if (!text) return text;
  let result = text;
  // Remove email addresses
  result = result.replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '');
  // Remove phone numbers (various formats)
  result = result.replace(/\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/g, '');
  // Remove website URLs
  result = result.replace(/https?:\/\/[^\s]+/g, '');
  // Remove 'Visit Website' or similar phrases
  result = result.replace(/visit (our )?website[^.]*\.?/gi, '');
  // Remove address-like patterns (e.g., 123 Main St, City, State ZIP)
  result = result.replace(/\d{1,5} [\w\s]+,? [A-Za-z\s]+,? [A-Za-z]{2,} ?\d{5}(-\d{4})?/g, '');
  // Remove extra whitespace but preserve paragraph breaks (\n\n)
  result = result.replace(/[ \t]+/g, ' '); // Replace multiple spaces/tabs with single space
  result = result.replace(/\n{3,}/g, '\n\n'); // Replace 3+ newlines with double newline
  result = result.trim();
  return result;
}

// Helper to parse comma-separated text into array
// Automatically converts line breaks to commas for consistency
export function parseListText(text: string | null | undefined): string[] {
  if (!text || typeof text !== 'string') return [];
  
  const trimmed = text.trim();
  if (trimmed === '') return [];
  
  // Convert line breaks to commas, then split by commas
  const normalizedText = trimmed.replace(/\n/g, ',');
  const items = normalizedText
    .split(',') // Split by comma only
    .map(item => item.trim()) // Trim whitespace
    .filter(item => item.length > 0); // Remove empty items
  
  return items;
}
